<template>
	<c-dialog ref="dialog" title="打印机设置" width="1000" height="600">
	</c-dialog>
</template>

<script>
	import getLodop from '@/assets/script/lodop.js'

	export default {
		name: 'printerConfig',

		props: {
		},

		data() {
			return {
			}
		},

		computed: {
		},
		
		methods: {
			async open() {
				// this.$refs.dialog.open();
				let LODOP = await getLodop(document.getElementById('LODOP_OB'), document.getElementById('LODOP_EM'));
				let printer = [], printerCount = LODOP.GET_PRINTER_COUNT();
				for (let i = 0; i < printerCount; i++) {
					printer.push(LODOP.GET_PRINTER_NAME(i))
				}
				console.log(printer)
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>